import { render } from "./OsdPractice.vue?vue&type=template&id=332ee89d&scoped=true"
import script from "./OsdPractice.vue?vue&type=script&lang=js"
export * from "./OsdPractice.vue?vue&type=script&lang=js"

import "./OsdStyles.css?vue&type=style&index=0&id=332ee89d&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332ee89d"]])

export default __exports__